import * as z from 'zod';

const protocol = 'vrplatform.embed.lifecycle';
const version = 1;
const envelope = {
  channelId: z.uuid(),
  protocol: z.literal(protocol),
  version: z.literal(version),
};
const channelRequestSchema = z
  .object({
    ...envelope,
    requestId: z.uuid(),
    type: z.literal('channel.request'),
  })
  .strict();
const channelConnectSchema = z
  .object({
    ...envelope,
    replyTo: z.uuid(),
    type: z.literal('channel.connect'),
  })
  .strict();
const iframeMessageSchema = z.discriminatedUnion('type', [
  z
    .object({
      ...envelope,
      type: z.literal('ready'),
    })
    .strict(),
  z
    .object({
      ...envelope,
      code: z.enum([
        'authentication_failed',
        'access_denied',
        'session_expired',
        'renewal_failed',
        'unsupported_version',
        'internal_error',
      ]),
      correlationId: z.string().min(1).max(128),
      recoverable: z.boolean(),
      replyTo: z.uuid().optional(),
      type: z.literal('error'),
    })
    .strict(),
  z
    .object({
      ...envelope,
      expiresAt: z.iso.datetime({ offset: true }),
      requestId: z.uuid(),
      type: z.literal('session.expiring'),
    })
    .strict(),
  z
    .object({
      ...envelope,
      expiresAt: z.iso.datetime({ offset: true }),
      replyTo: z.uuid(),
      type: z.literal('session.renewed'),
    })
    .strict(),
  z
    .object({
      ...envelope,
      height: z.number().int().positive(),
      type: z.literal('resize'),
    })
    .strict(),
]);
const parentMessageSchema = z.discriminatedUnion('type', [
  z
    .object({
      ...envelope,
      embedUrl: z.url(),
      replyTo: z.uuid(),
      requestId: z.uuid(),
      type: z.literal('session.renew'),
    })
    .strict(),
]);

export const embedLifecycle = {
  channelConnectSchema,
  channelRequestSchema,
  iframeMessageSchema,
  parentMessageSchema,
  protocol,
  version,
} as const;

export type EmbedLifecycleChannelConnect = z.infer<typeof channelConnectSchema>;
export type EmbedLifecycleChannelRequest = z.infer<typeof channelRequestSchema>;
export type EmbedLifecycleIframeMessage = z.infer<typeof iframeMessageSchema>;
export type EmbedLifecycleParentMessage = z.infer<typeof parentMessageSchema>;
